import logoAnimated from 'Assets/Icons/logo-animated.svg';
import Loader from 'Components/Atoms/Loader/Loader';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

export const LoadingPage = () => {
    const [opacity, setOpacity] = useState(0);
    
    let cssClass: any = {
        position: 'relative',
        width: '100vw',
        height: '100vh',
        transition: '.4s all ease-in',
        opacity: opacity
    };

    useEffect(() => {
        setOpacity(1);
    }, []);

    return (
        <div style={cssClass}>
            <Helmet>
                <title>Loading...</title>
            </Helmet>
            
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                width: '300px'
            }}>
                <img src={logoAnimated} alt='logo' />
                <Loader />
            </div>
        </div>
    )
}
